import { defineMessages } from 'utils/intl';

export default defineMessages({
  title: 'Charge on the go',
  subtitle:
    'Niezależnie od tego, gdzie na świecie zaprowadzą Cię Twoje przygody, podróżuj pewnie z REDARC Electronics.',
});
